<template lang="pug">

.ge-ti
	NoSignal
	.ge-ti-info
		.he-top
			.he-top-info
				.he-top-info-itm
					i: font-awesome-icon(icon="calendar-alt")
					.he-top-info-itm__date(v-if="$parent.isCurrentMatchLoaded")
						span {{ date }}
						span {{ time }}

			.he-top__round(@click="toggleNav" role="button")
				i: font-awesome-icon(icon="chevron-left")
				span(v-if="$parent.isCurrentMatchLoaded") {{round}}


			router-link.he-top-logo(v-if="!$store.state.general.isApp" :to="{name: $store.state.general.lang+'.home'}")
				img(src="/acb-live.png", alt="acb live")

			.he-top-logo(v-if="$store.state.general.isApp")
				img(src="/acb-live.png", alt="acb live")

			img.he-top__comp(
				v-if="competitionLogoNegative && $parent.isCurrentMatchLoaded"
				:src="competitionLogoNegative"
				:alt="competitionName"
			)


	.ge-ti-cnt-wrap: .ge-ti-cnt
		.ge-ti-cnt-vs(v-if="$parent.isCurrentMatchLoaded")
			img.ge-ti-cnt-vs__shield(:src="localNegativeImage")
			span.ge-ti-cnt-vs__text vs
			img.ge-ti-cnt-vs__shield(:src="visitorNegativeImage")

		span.ge-ti-cnt__cta {{ $t('Upcoming') }}
	img.ge-ti__bg(src="/por-empezar.jpg", alt="partido no encontrado")

</template>

<script>
import NoSignal from "@/components/subcomponents/head/NoSignal.vue";

export default {
	name: "Upcoming",
	props: {
		date: String,
		time: String,
		round: String,
		localNegativeImage: String,
		visitorNegativeImage: String,
		competitionLogoNegative: String,
		competitionName: String

	},
	methods: {
		async toggleNav() {
			await this.$store.commit('general/setNav', 1)
			this.scrollToActiveElement()
		},
		scrollToActiveElement() {
			const element = document.querySelector(".nav-top-sec-swipe-item--selected")
			const parent = document.querySelector(".nav-top-sec-swipe")
			var position = element.offsetLeft - (parent.getBoundingClientRect().width - element.getBoundingClientRect().width) / 2;
			parent.scrollTo({ top: 0, left: position, behavior: "auto" })
		}
	},
	components: {
		NoSignal,
	}

};

</script>